import { CalendarTranslateService } from './../../../../modules/UIKit/services/calendarTranslate.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-campaign-action-list',
  templateUrl: './campaign-action-list.component.html',
  styleUrls: ['./campaign-action-list.component.css']
})
export class CampaignActionListComponent implements OnInit {
  @Input() campaignId: number;
  @Input() campaignName: string;
  @Input() campaignAction: any;
  @Output() onGetCampaignList: EventEmitter<any> = new EventEmitter();
  @Output() onCreateCampaignAction: EventEmitter<any> = new EventEmitter();
  @Output() onOpenPopUpDuplicateActions: EventEmitter<any> = new EventEmitter();
  @Output() onClosePopUpDuplicateActions: EventEmitter<any> = new EventEmitter();
  @Output() onRefreshCampaignActionList: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteAction: EventEmitter<any> = new EventEmitter();
  @Output() onDeployAction: EventEmitter<number> = new EventEmitter();
  @Output() onOpenActionGenerated: EventEmitter<any> = new EventEmitter();
  @Output() onViewAction: EventEmitter<any> = new EventEmitter();
  @Output() onConfirmPreview: EventEmitter<any> = new EventEmitter();
  @Output() onConfirmPublish: EventEmitter<any> = new EventEmitter();
  @Output() onGenerateCoupon: EventEmitter<any> = new EventEmitter();
  @Output() onShowCoupon: EventEmitter<any> = new EventEmitter();

  constructor(
    public calendarTranslateService: CalendarTranslateService
  ) { }

  ngOnInit() {
  }

  createCampaignAction(){
    this.onCreateCampaignAction.emit();
  }

  openPopUpDuplicateActions(){
    this.onOpenPopUpDuplicateActions.emit();
  }

  closePopUpDuplicateAction(){
    this.onClosePopUpDuplicateActions.emit();
  }

  refreshCampaignActionList() {
    this.onRefreshCampaignActionList.emit();
  }

  deleteAction(action: any) {
    this.onDeleteAction.emit(action);
  }

  deployAction(messageInstanceId: number) {
    this.onDeployAction.emit(messageInstanceId);
  }

  openActionGenerated(action: any) {
    this.onOpenActionGenerated.emit(action);
  }

  viewAction(action: any) {
    this.onViewAction.emit(action);
  }

  confirmPreview(action: any) {
    this.onConfirmPreview.emit(action);
  }

  confirmPublish(action: any) {
    this.onConfirmPublish.emit(action);
  }

  generateCoupon(action: any) {
    this.onGenerateCoupon.emit(action);
  }

  showCoupon(action: any) {
    this.onShowCoupon.emit(action);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-list2/campaign-action-list/campaign-action-list.component.ts